var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker, FormControl, FormLabel, useFieldContext } from 'shared/components';
import { SingleLineReadOnly } from 'shared/components/features/Form/SingleLineReadOnly';
export var InteractionDate = function () {
    var _a = useFormContext(), control = _a.control, getValues = _a.getValues;
    var readOnly = useFieldContext().readOnly;
    return (_jsxs(FormControl, __assign({ mr: readOnly ? 3 : 2, width: readOnly ? 'auto' : '316px', isRequired: true }, { children: [_jsx(FormLabel, __assign({ htmlFor: "interactionDate", mr: readOnly ? 0 : 'inherit' }, { children: "Date of Interaction" })), readOnly && (_jsx(SingleLineReadOnly, { text: DateTime.fromJSDate(getValues().interactionDate).toFormat('ccc MMM d, yyyy') })), !readOnly && (_jsx(Controller, { "data-testid": "interactionDate", control: control, name: "interactionDate", rules: {
                    required: 'You must enter the date of this interaction.',
                }, render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref;
                    return (_jsx(DatePicker, { defaultDate: getValues().interactionDate, onChange: onChange, onBlur: onBlur, value: value, name: name, maxDate: getValues().interactionDate }));
                } }))] })));
};
